import React from 'react';
import { getJSON } from 'redux-api-middleware';
import { CASE_TYPE_NTB, CASE_ID } from './constants';
import CBLogo from '../images/favicon-cb.png';
import YBLogo from '../images/favicon-yb.png';
import VMLogo from '../images/vm-favicon.png';

const sameAsPersonalAddress = 'Same as my personal address';
const Yes = 'Yes';
const sameAsRegisteredAddress = 'Same as my company’s registered office address';
const sameAsTradingAddress = 'Same as my trading address';
let hrefOnBrowserLoad;

export function removeHashUrl(newHash) {
  if (window.history.pushState) {
    window.history.replaceState(
      '',
      '/',
      !newHash ? window.location.pathname : `${window.location.pathname}#${newHash}`
    );
  } else {
    window.location.hash = newHash || '';
  }
}
export function DateSplitter(date) {
  if (date) {
    const data = date.split('-');
    return { dateField: data[2], monthField: data[1], yearField: data[0] };
  }
}
export function SortCodeSplitter(sortcode) {
  if (sortcode) {
    const sortArray = sortcode.match(/.{1,2}/g);
    return { sortField1: sortArray[0], sortField2: sortArray[1], sortField3: sortArray[2] };
  }
  return '';
}
export function convertStringToYesNo(value) {
  if (value === 'Y') {
    return 'Yes';
  } else if (value === 'N') {
    return 'No';
  }
  return '';
}
export function getType(address, register, trading, mailing) {
  if (address === 'registeredAddress') {
    return register;
  }
  if (address === 'tradingAddress') {
    return trading;
  }
  if (address === 'mailingAddress') {
    return mailing;
  }
}
export function getAddressPrefix(address) {
  if (address) {
    const addressPrefix = [
      address.substr(0, address.indexOf(' ')),
      address.substr(address.indexOf(' ') + 1)
    ];
    return addressPrefix;
  }
  return '';
}
export const getRegisteredAddress = (
  showRegisterPostCode,
  address,
  values,
  registerAddressSelect
) => {
  if (values.tradingAddress === sameAsPersonalAddress) {
    return address;
  }
  if (values.tradingAddress === sameAsRegisteredAddress || values.tradingAddress === Yes) {
    return getSameAsRegisteredAddress(showRegisterPostCode, registerAddressSelect, address);
  }
};
export const getTradingAddress = (
  showRegisterPostCode,
  showTradingPostCode,
  address,
  values,
  registerAddressSelect,
  tradingAddressSelect
) => {
  switch (values.mailingAddress) {
    case sameAsPersonalAddress:
      return address;

    case sameAsRegisteredAddress:
      return getSameAsRegisteredAddress(showRegisterPostCode, registerAddressSelect, address);

    case sameAsTradingAddress:
      if (showTradingPostCode && values.tradingAddressSelectAddress) {
        return tradingAddressSelect;
      }
      return getRegisteredAddress(showRegisterPostCode, address, values, registerAddressSelect);
    default:
  }
};
const getSameAsRegisteredAddress = (showRegisterPostCode, registerAddressSelect, address) => {
  if (showRegisterPostCode && registerAddressSelect) {
    return registerAddressSelect;
  }
  return address;
};
export const getAddress = (values, address) => {
  if (values.registeredAddress === Yes) {
    return address;
  }
};
export const checkEmptyFieldValue = (fieldValue) => {
  return (
    fieldValue !== 'undefined' &&
    fieldValue !== undefined &&
    fieldValue !== null &&
    fieldValue !== ''
  );
};
export function getAnchorTagInString(keyFeatureTitle1, keyFeatureTitle2, hyperlink) {
  return (
    <span>
      {keyFeatureTitle1} {getAnchorTag(keyFeatureTitle2, hyperlink)}
    </span>
  );
}
export function getAnchorTag(content, link) {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  );
}
export function getHyperlink(CBLink, YBLink, bankId) {
  return bankId.toUpperCase() === 'CB' ? CBLink : YBLink;
}
/**
 * To save href on application loading, this is required to implement inter app communication
 */
export const saveHrefOnBrowserLoad = () => {
  hrefOnBrowserLoad = window.location.href;
};

/**
 * Return saved  href on application loading
 */
export const getHrefOnBrowserLoad = () => hrefOnBrowserLoad;

export const getQueryStringValueByName = function (field, url) {
  const href = url ? url : hrefOnBrowserLoad;
  const reg = new RegExp(`[?&#]${field}=([^&#]*)`);
  const items = reg.exec(decodeURIComponent(href));
  return items ? items[1] : null;
};

export const validateRouteToRedirect = (page) => {
  return hrefOnBrowserLoad.indexOf(page.replace('/', '')) > -1;
};

export const getPayload = (_action, _state, res) =>
  getJSON(res).then((json) => {
    res.json = json;
    return json;
  });

export const checkValue = (val) =>
  val && val.trim() !== 'undefined' && val.replace(/ /g, '')
    ? `${val.replace('undefined', '')},
`
    : '';

export const getEvidenceUrl = (subtype, caseId) => {
  const caseSubtype = subtype === CASE_TYPE_NTB ? CASE_TYPE_NTB : 'existing/newbusiness';
  return `:api_paas_url/banks/:bank_id/cases/bsap/${caseSubtype}/${caseId}/evidence`;
};

export const onKeyPress = (event) => {
  const ENTER_KEY_CODE = 13;
  if (event.which === ENTER_KEY_CODE) {
    event.preventDefault();
  }
};
export const isDisabledBasedOnRedirectUri = () => {
  return !getQueryStringValueByName(CASE_ID);
};

export const applyFaviconBasedOnBrandId = (brandId) => {
  const head = document.querySelector('head');
  const favicon = document.createElement('link');
  favicon.type = 'image/x-icon';
  favicon.rel = 'shortcut icon';
  favicon.href = brandId === 'VM' ? VMLogo : brandId === 'YB' ? YBLogo : CBLogo;
  favicon && head.appendChild(favicon);
};
